export default __webpack_public_path__ + "static/media/G-1.2839283d.svg";